import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';

const initialState = {
  loading: false,
  usersList: []
};
const users = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getUsersList(state, action) {
      return {
        ...state,
        usersList: action.payload?.data?.result || [],
        count: action.payload?.data?.count
      };
    },
    getUserById(state, action) {
      return {
        ...state,
        userInfo: action.payload?.data
      };
    },
    getCurrentUserById(state, action) {
      return {
        ...state,
        currentUserInfo: action.payload?.data
      };
    }
  }
});

export default users.reducer;

export const UsersActions = users.actions;

export const createUser = (role) => async () => {
  try {
    const res = await api.post(`api/User`, role);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const editUser = (data, id) => async () => {
  try {
    const res = await api.put(`api/User/${id}`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const getUsersAction = (data) => async (dispatch) => {
  dispatch(UsersActions.setLoading(true));
  try {
    // Build filtering object from parameters
    const memberFilters = [];

    // Add search filter
    if (data?.searchText) {
      memberFilters.push({
        name: 'Search',
        comparison: 9,
        value: data.searchText
      });
    }

    // Add isExternal filter
    if (data?.isExternal !== undefined) {
      memberFilters.push({
        name: 'IsExternal',
        comparison: 1,
        value: data.isExternal
      });
    }

    // Add roleId filter
    if (data?.roleId) {
      memberFilters.push({
        name: 'RoleId',
        comparison: 1,
        value: data.roleId
      });
    }

    // Add status filters (one memberFilter per checked status)
    if (data?.statuses && data.statuses.length > 0) {
      data.statuses.forEach((status) => {
        memberFilters.push({
          name: 'Status',
          comparison: 1,
          value: status
        });
      });
    }

    const requestPayload = {
      paging: {
        skip: (data?.pageIndex - 1) * data?.pageSize || 0,
        take: data?.pageSize || 10
      },
      ...(memberFilters.length > 0 && {
        filtering: {
          compositionType: 2,
          memberFilters
        }
      })
    };

    // Add sorting if provided
    if (data?.orderBy && data?.orderDir) {
      const capitalizeFirstLetter = (str) =>
        str.charAt(0).toUpperCase() + str.slice(1);

      requestPayload.sorting = [
        {
          memberName: `User.${capitalizeFirstLetter(data.orderBy)}`,
          direction: data.orderDir === 'Asc' ? 2 : 1
        }
      ];
    }

    const res = await api.post(`api/User/Filter`, requestPayload);
    if (res.status === 200 && res?.data) {
      console.log(2342342, res?.data);
      dispatch(UsersActions.getUsersList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors?.response?.data);
  } finally {
    dispatch(UsersActions.setLoading(false));
  }
};
export const getUserById = (id) => async (dispatch) => {
  dispatch(UsersActions.setLoading(true));
  try {
    const res = await api.get(`api/User/${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(UsersActions.getUserById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(UsersActions.setLoading(false));
  }
};
export const getCurrentUserById = (id) => async (dispatch) => {
  dispatch(UsersActions.setLoading(true));
  try {
    const res = await api.get(`api/User/${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(UsersActions.getCurrentUserById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(UsersActions.setLoading(false));
  }
};
export const removeUserAction =
  (id, setRemoveDialog, filterParams) => async (dispatch) => {
    try {
      const res = await api.delete(`api/User/${id}`);
      if (res.status === 200 && res?.data) {
        // If filter params provided, use them to refresh the list
        if (filterParams) {
          dispatch(getUsersAction(filterParams));
        } else {
          // Otherwise just refresh with default params
          dispatch(
            getUsersAction({
              pageIndex: 1,
              pageSize: 10
            })
          );
        }
        setRemoveDialog('');
        toast.success('Removed successfully!!!');
      }
    } catch (errors) {
      formErrorsHandle(errors.response?.data, []);
    }
  };
export const editCurrentUser = (data) => async () => {
  try {
    const res = await api.put(`api/User/UpdateOwnUser`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const resendEmailAction = (id) => async () => {
  try {
    const res = await api.post(`api/User/resend?id=${id}`);
    if (res.status === 200) {
      toast.success('Email sent successfully!');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    toast.error('Failed to send email');
    return Promise.reject(errors.response?.data);
  }
};
export const toggleActivationAction =
  (id, filterParams) => async (dispatch) => {
    try {
      const res = await api.patch(`api/User/${id}/toggle-activation`);
      if (res.status === 200) {
        toast.success('User status updated successfully!');
        dispatch(getUsersAction(filterParams));
      }
    } catch (errors) {
      const message =
        errors?.response?.data?.message || 'Failed to update user status';
      toast.error(message);
    }
  };
